<template>
  <div class="nch--blog-tag header">
    <div class="nch--blog-container">
      <h2 class="nch--blog-title">#{{ tag.translation.name }}</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    value: {
      type: Object,
      description: 'Tag object',
      required: true,
    },
  },
  computed: {
    tag() {
      return this.value;
    },
  },
};
</script>

<style scoped>
.nch--blog-tag.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
}
.nch--blog-tag .nch--blog-container {
  width: 100%;
  text-align: left;
}
.nch--blog-tag.header h2.nch--blog-title {
  color: var(--blog-text);
  font-size: 2.5rem;
  text-align: left;
  width: 100%;
  margin-top: 1rem;
}
@media (max-width: 900px) {
  .nch--blog-tag.header h2.nch--blog-title {
    font-size: 2rem;
  }
}
</style>
